type SalesReportPayloadModel = {
  start_date: string
  end_date: string
  limit?: number
}

type MenuItemsSalesTableByLanguagePayloadModel = {
  startDate: string
  endDate: string
  limit?: number
  itemFilter?: 'dish' | 'topping' | 'danie' | 'dodatek' | null
}

type IngredientsSalesTableByLanguagePayloadModel = {
  startDate: string
  endDate: string
  limit?: number
  typeFilter?:
    | 'count'
    | 'weight'
    | 'volume'
    | 'ilość'
    | 'waga'
    | 'objętość'
    | null
}

type InventoryPdfPayloadModel = {
  language?: string
  startDate: string
  endDate: string
  limit?: number
  typeFilter?:
    | 'count'
    | 'weight'
    | 'volume'
    | 'ilość'
    | 'waga'
    | 'objętość'
    | null
}

type DishesPdfPayloadModel = {
  language?: string
  startDate: string
  endDate: string
  limit?: number
  itemFilter?: 'dish' | 'topping' | 'danie' | 'dodatek' | null
}

type MenuItemsSalesExcelPayloadModel = {
  language?: string
  startDate: string
  endDate: string
  limit?: number
  itemFilter?: 'dish' | 'topping' | 'danie' | 'dodatek' | null
}

type IngredientsSalesExcelPayloadModel = {
  language?: string
  startDate: string
  endDate: string
  limit?: number
  typeFilter?:
    | 'count'
    | 'weight'
    | 'volume'
    | 'ilość'
    | 'waga'
    | 'objętość'
    | null
}

type SalesReportDataModel = {
  totalSalesAmount: number
  totalSalesCount: number
  items: [
    {
      itemNo: number
      itemName: string
      price: number
      quantity: number
      percentage: number
      type: string
    }
  ]
}

type MenuItemsSalesTableByLanguageItemModel = {
  translations: Record<string, string>
  price: number
  quantity: number
  percentage: number
  translationsType: Record<string, string>
  itemId: string
}

type MenuItemsSalesTableByLanguageResponseModel = {
  totalSalesAmount: number
  totalSalesCount: number
  translationCoverage: Record<string, number>
  items: MenuItemsSalesTableByLanguageItemModel[]
}

type SalesReportResponseModel = SalesReportDataModel[]

enum QUERY {
  DISHES_AND_TOPPINGS_SALES_REPORT = 'dishesAndToppingsSalesReport',
  INGREDIENTS_SALES_REPORT = 'ingredientsSalesReport',
  MENU_ITEMS_SALES_TABLE_BY_LANGUAGE = 'menuItemsSalesTableByLanguage',
  INGREDIENTS_SALES_TABLE_BY_LANGUAGE = 'ingredientsSalesTableByLanguage',
  INVENTORY_PDF = 'inventoryPdf',
  DISHES_SALES_PDF = 'dishesSalesPdf',
  MENU_ITEMS_SALES_EXCEL = 'menuItemsSalesExcel',
  INGREDIENTS_SALES_EXCEL = 'ingredientsSalesExcel'
}

export { QUERY }
export type {
  SalesReportPayloadModel,
  SalesReportResponseModel,
  MenuItemsSalesTableByLanguagePayloadModel,
  IngredientsSalesTableByLanguagePayloadModel,
  InventoryPdfPayloadModel,
  DishesPdfPayloadModel,
  MenuItemsSalesExcelPayloadModel,
  IngredientsSalesExcelPayloadModel,
  MenuItemsSalesTableByLanguageItemModel,
  MenuItemsSalesTableByLanguageResponseModel
}
